import React, { Component } from 'react'
import ReactDOM from 'react-dom'

import EstimationStore from '../libs/EstimationStore'
import EstimationActions from '../libs/EstimationActions'

class RadioButton extends Component {
  constructor (props) {
    super(props)
    this.state = {
      bindingDataAttribute: this.props.bindingDataAttribute,
      data: EstimationActions.getCurrentEstimation(),
      listener: null
    }
  }
  componentDidMount () {
    this.setState({
      listener: EstimationStore.addListener('change', () => {
        this.setState({
          data: EstimationActions.getCurrentEstimation()
        })
      })
    })
  }
  componentWillUnmount () {
    if (this.state.listener) this.state.listener.remove()
  }
  getDataValue () {
    if (this.props.isList) {
      let listName = this.props.listName
      let index = this.props.index
      return this.state.data[listName][index][this.state.bindingDataAttribute]
    }
    return this.state.data[this.state.bindingDataAttribute]
  }
  changeData () {
    const changedValue = ReactDOM.findDOMNode(this.refs.radiobutton).value
    if (this.props.isList) {
      let listName = this.props.listName
      let index = this.props.index
      EstimationActions.updateListInCurrentEstimation(listName, index, this.state.bindingDataAttribute, changedValue)
    } else {
      EstimationActions.updateCurrentEstimation(this.state.bindingDataAttribute, changedValue, this.props.callback)
    }
  }
  render () {
    const attributeValue = this.props.attributeValue
    return (
      <input type='radio' ref='radiobutton' id={this.props.idForLabel} name={this.state.bindingDataAttribute} checked={this.getDataValue() === attributeValue} value={attributeValue} onChange={this.changeData.bind(this)} />
    )
  }
}

RadioButton.defaultProps = {isList: false, idForLabel: ''}
export default RadioButton



// WEBPACK FOOTER //
// ./src/company_user/components/RadioButton.js